import { BtnChiTietHopDong } from "components/ThongKe/DanhSachHopDongBiXoa/ChiTietHopDong/BtnChiTietHopDong";
import React from "react";
import PhanTrang from "components/CommonComponent/PhanTrang";
import { formatMoney } from "utils/currencyFormat";
import { catChuoi } from "utils/stringExtension";

const ContentTable = ({
  dataDanhSach,
  selectedIds,
  onSelectOne,
  onShowContractDetail,
  onShowCustomerInfo,
  onPrintContract,
  onCancelContract,
}) => {
  return (
    <>
      {dataDanhSach.List.map((item, index) => (
        <div className="custom-table-row" key={item.Id || index}>
          <div className="custom-table-cell flex-basis-5 flex-basis-5-sm text-center">
            <input
              type="checkbox"
              checked={item.TrangThai === 2 && selectedIds.includes(item.Id)}
              disabled={item.TrangThai !== 2}
              onChange={(e) => onSelectOne(item.Id, e.target.checked)}
            />
          </div>
          <div className="custom-table-cell username-cell flex-basis-5 flex-basis-5-sm disk-mobile left-center">
            {index + 1}
          </div>
          <div className="custom-table-cell flex-basis-10 flex-basis-10-sm left-center">
            <p className="text-left color-xanh-do">
              <BtnChiTietHopDong item={item} />
            </p>
          </div>
          <div className="custom-table-cell flex-basis-15 flex-basis-15-sm left-center">
            <p className="text-left color7">
              {item.CustomerName}
              <br />
              {item.Phone && (
                <span title={item.Phone}> {catChuoi(item.Phone, 10)}</span>
              )}
            </p>
          </div>
          <div className="custom-table-cell flex-basis-10 flex-basis-10-sm text-left">
            <p className="text-left color7">
              {" "}
              {item.LoaiHopDong ||
                (item.Type === 1
                  ? "Tín Chấp"
                  : item.Type === 2
                    ? "Trả Góp"
                    : item.Type === 3
                      ? "Cầm đồ"
                      : "-")}
            </p>
          </div>
          <div className="custom-table-cell flex-basis-10 flex-basis-10-sm text-left">
            <p className="text-left color7">{formatMoney(item.SoTienVay)}</p>
          </div>
          <div className="custom-table-cell flex-basis-10 flex-basis-10-sm text-left">
            <p className="text-left color7">{item.NgayTao || "-"}</p>
          </div>
          <div className="custom-table-cell flex-basis-15 flex-basis-15-sm text-left">
            <p className="text-left color7">{item.CreatedBy}</p>
          </div>
          <div className="custom-table-cell flex-basis-10 flex-basis-10-sm text-left">
            <p className="text-left color7">
              <span
                className={
                  item.TrangThai === -1
                    ? "canh-bao-red-v2"
                    : item.TrangThai === 0
                      ? "canh-bao-no"
                      : item.TrangThai === 2
                        ? "dang-vay"
                        : "dong"
                }
              >
                {item.TrangThai === 0
                  ? "Chưa ký"
                  : item.TrangThai === 1
                    ? "Đang ký"
                    : item.TrangThai === 2
                      ? "Đã ký"
                      : item.TrangThai === -1
                        ? "Đã hủy"
                        : "-"}
              </span>
            </p>
          </div>
          <div className="custom-table-cell flex-basis-5 flex-basis-5-sm text-left">
            <p className="text-left color7">{item.LyDo}</p>
          </div>
          <div className="custom-table-cell flex-basis-5 flex-basis-5-sm action-cell text-left">
            {item.TrangThai === 2 && (
              <>
                {/* <button
                  type="button"
                  className="btn btn-new-main btn-checknew disk-mobile"
                  onClick={() => onPrintContract(item)}
                  style={{ height: "35px", marginRight: "8px" }}
                >
                  <img src="/app-assets/images/icon-in-danh-sach.png" />
                  &nbsp;
                  <span>In</span>
                </button> */}
                <a
                  className="iconTableMorman"
                  title="In"
                  onClick={() => onPrintContract(item)}
                >
                  <img
                    src="/app-assets/images/icon-in-danh-sach.png"
                    alt="In"
                  />
                </a>
                &nbsp;
                <a
                  className="iconTableMorman"
                  title="Hủy"
                  onClick={() => onCancelContract(item)}
                >
                  <img src="/app-assets/images/icon-xoa-v2.png" />
                </a>
              </>
            )}
          </div>
        </div>
      ))}
    </>
  );
};

export const TableDanhSach = ({
  dataDanhSach,
  dataSearch,
  setDataSearch,
  onSearch,
  selectedIds,
  onSelectAll,
  onSelectOne,
  onShowContractDetail,
  onShowCustomerInfo,
  onPrintContract,
  onCancelContract,
}) => {
  // onSearch đọc dataSearch qua closure nên phải sửa trực tiếp object trước khi gọi
  const handlePageChange = (pageNumber) => {
    dataSearch.iPageIndex = pageNumber;
    setDataSearch({ ...dataSearch });
    onSearch();
  };

  const handlePageSizeChange = (pageSize) => {
    dataSearch.iPageSize = pageSize;
    dataSearch.iPageIndex = 1;
    setDataSearch({ ...dataSearch });
    onSearch();
  };

  const selectableRows =
    dataDanhSach.List && dataDanhSach.List.length > 0
      ? dataDanhSach.List.filter((item) => item.TrangThai === 2)
      : [];
  const allSelected =
    selectableRows.length > 0 && selectedIds.length === selectableRows.length;

  return (
    <>
      <div
        className="card border-light mb-3 card-v2"
        style={{ marginLeft: "15px", marginRight: "15px" }}
      >
        <div className="card-body card-body-v2">
          <div className="Left808x200 Table-main-new">
            <div className="table-mobile table-mobile-hover">
              <div className="custom-table-wrapper">
                <div className="table-headers">
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-left">
                      <input
                        type="checkbox"
                        checked={allSelected}
                        onChange={(e) => onSelectAll(e.target.checked)}
                      />
                    </p>
                  </div>
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm ">
                    <p className="text-left">STT</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="left-center">Mã hợp đồng</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="left-center">Tên khách hàng</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="text-left">Loại hợp đồng</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="text-left">Số tiền vay</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="text-left">Ngày tạo</p>
                  </div>
                  <div className="custom-table-header flex-basis-15 flex-basis-15-sm">
                    <p className="text-left">Người tạo</p>
                  </div>
                  <div className="custom-table-header flex-basis-10 flex-basis-10-sm">
                    <p className="text-left">Trạng thái</p>
                  </div>
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-left">Lý do</p>
                  </div>
                  <div className="custom-table-header flex-basis-5 flex-basis-5-sm">
                    <p className="text-left">Thao tác</p>
                  </div>
                </div>
                <div className="custom-table-body">
                  {dataDanhSach.List && dataDanhSach.List.length > 0 ? (
                    <ContentTable
                      dataDanhSach={dataDanhSach}
                      selectedIds={selectedIds}
                      onSelectOne={onSelectOne}
                      onShowContractDetail={onShowContractDetail}
                      onShowCustomerInfo={onShowCustomerInfo}
                      onPrintContract={onPrintContract}
                      onCancelContract={onCancelContract}
                    />
                  ) : (
                    <div className="p-4 text-left">Không có dữ liệu</div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div
        className="card border-light mb-3 card-v2"
        style={{ marginLeft: "15px", marginRight: "15px" }}
      >
        <div className="card-body card-body-v2">
          <PhanTrang
            pageIndex={dataSearch.iPageIndex}
            pageSize={dataSearch.iPageSize}
            totalCount={dataDanhSach.iTotal}
            onPageChange={handlePageChange}
            onPageSizeChange={handlePageSizeChange}
          />
        </div>
      </div>
    </>
  );
};
